import { gql } from '@apollo/client';
export const UPDATE_MEETING_PARTICIPATION_STATUS = gql(`mutation updateMeetingParticipationStatus($payload: [sch_update_meeting_participant_status_input!]) {
    sch_update_meeting_participant_status(data: $payload){
      data
      success
     error_message
    }
  }
`);
export const GET_LEGACY_LIVE_SESSION = gql `
  query frm_legacy_live_session($id: bigint!) {
    frm_legacy_live_session(id: $id) {
      assessment_section_candidate {
        assessment_section {
          section {
            external_id
          }
        }
      }
    }
  }
`;
